let names;
try {
  names = new Intl.DisplayNames([ 'en-US' ], { type: 'region' });
} catch (e) {
  // 'Intl.DisplayNames' is not supported
  names = { of: v => v };
}
export default cc => cc && names.of(cc);
